import { HttpParams } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, Renderer2 } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { MagnifyFieldSearchComponent } from '../magnify-field-search/magnify-field-search.component';
import { NavigationExtras, Router } from '@angular/router';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';
const FILTER_PAG_REGEX = /[^0-9]/g;

@Component({
  selector: 'app-advance-gridview',
  templateUrl: './advance-gridview.component.html',
  styleUrls: ['./advance-gridview.component.css']
})

export class AdvanceGridviewComponent implements OnInit, AfterViewInit {
  @Input() recordsPerPage: number = 50;


  @Input() currentPage: number = 1;

  @Input() Isserversidepaginationenabled: boolean = false;
  // lstFilteredData: any = [];
  txtURN: string = '';
  txtInputFrom: string = '';
  txtInputType: string = '';
  ddlPriority: string = '';
  isDateRangeHasValue = false;
  len: number;
  maxDate = new Date();
  invoiceCreationDateRange = new FormGroup({
    start_date: new FormControl(),
    end_date: new FormControl(),
  });

  lstPriority: any = [
    { value: '', text: 'All' },
    { value: 'NORMAL', text: 'Normal' },
    // { value: 'MEDIUM', text: 'Medium' },//'Medium', arun decided to remove from the priority 
    //discussed and confirmed on 13-06-2022.
    { value: 'HiGH', text: 'High' },
  ];

  lstrecordsPerPage = [10, 50, 100];
  isMasterSel: boolean;

  private _lstData: any[];
  total_records: number;
  pagearray: number[];
  NewPage: number = 1;
  pretrail: boolean = false;
  posttrail: boolean = false;
  @Input() set lstData(value: any[]) {

    this._lstData = value;
    this.recordsPerPage = Number(this.recordsPerPage)

    if (this._lstData[0].TotalRecordsCount != undefined) {
      this.Isserversidepaginationenabled = true
    }

    this.NewPage = this.currentPage;
    this.currentPage = 1;

    var len = this.lstData.length;

    if (this.lstData.length > 0 && this.Isserversidepaginationenabled == true) {
      len = this.lstData[0].TotalRecordsCount
    }
    this.total_records = len;

    this.totalPages = Math.ceil(len / this.recordsPerPage);
    this.pagearray = Array.from({ length: this.totalPages }, (_, i) => i + 1) // to display pages

    this.firstRecord = (this.lstData.length === 0 ? 0 : ((this.NewPage * this.recordsPerPage) - this.recordsPerPage) + 1);
    var val = (Number(this.firstRecord - 1) + Number(this.recordsPerPage));

    this.LastRecord = (val < len) ? val : len;
    //  this.LastRecord = (this.recordsPerPage < len) ? this.recordsPerPage : len;
    // this.lstFirst = this._lstData[0];
    // if (this._lstData.length > 1) {
    //   this._lstData[0] = this._lstData[0].slic
    //   this._lstData[0].splice(0, 1);
    // }
  }

  get lstData(): any[] {
    return this._lstData;
  }

  // @Input() lstData: any[] = [];
  @Input() lstHeaders = [];
  @Input() gridTitle: string = "";
  @Input() showColumnGroup: boolean = true;
  @Input() showAdvanceSearchOption: boolean = true;
  @Input() advanceSearchFields: any[] = [];
  @Input() showExcelDownloadOption: boolean = true;
  @Input() isLiteTheme: boolean = false;
  @Input() identityColumnName: string = '';
  @Input() columnsToHide: any = [];
  @Input() isOpenAdvanceSearch = false;


  @Output() downloadalldata = new EventEmitter<any>();
  @Output() cellClickEvent = new EventEmitter<any>();
  @Output() headercheckboxClickEvent = new EventEmitter<any>();
  @Output() advanceSearchClickEvent = new EventEmitter<any>();
  @Output() columnsFilterChangeEvent = new EventEmitter<any>();
  @Output() setPaginationLocalStorageEvent = new EventEmitter<any>();
  @Output() dropDownClickEvent = new EventEmitter<any>();
  @ViewChild('scrollableGrid') scrollableGrid: ElementRef;

  totalPages = 1;
  firstRecord = 1;
  LastRecord = 1;

  firstHeader: any;


  showAdvanceSearch: boolean = false;
  sortColumnInfo = { name: '', isOrderAsc: true };
  isDataFiltered: boolean = false;

  nextTransactionCount: any = 10;



  constructor(public commonService: CommonService, private modalService: NgbModal, private dataService: DataService, private renderer: Renderer2, private router: Router,private memorystore: MemoryStorageService,private encryptDecryptservice: EncryptDecryptService) {
    this.isMasterSel = false;
  }

  // ngAfterViewInit(): void {
  // }
  @ViewChild('displayGrid', { static: false }) displayGridref!: ElementRef;
  ngAfterViewInit() {
    this.renderer.removeAttribute(this.displayGridref.nativeElement, 'aria-haspopup');
  }

  ngOnInit(): void {
    this.nextTransactionCount = this.dataService.next_transaction_count;
    if (this.nextTransactionCount == undefined || this.nextTransactionCount == '')
      this.nextTransactionCount = 10;
    var len = this.lstData.length;
    if (this.lstData.length > 0 && this.Isserversidepaginationenabled == true) {
      len = this.lstData[0].TotalRecordsCount
    }
    this.total_records = len
    this.totalPages = Math.ceil(len / this.recordsPerPage);
    this.pagearray = Array.from({ length: this.totalPages }, (_, i) => i + 1) // to display pages

    this.firstRecord = ((this.currentPage * this.recordsPerPage) - this.recordsPerPage) + 1;
    var val = (Number(this.firstRecord - 1) + Number(this.recordsPerPage));

    this.LastRecord = (val < len) ? val : len;


    // this.lstFilteredData = this.lstData;
    this.checkDataFiltered();

    this.showAdvanceSearch = this.isOpenAdvanceSearch;
  }

  onCellClick(columnName: String, rowData: any, rowIndex: number = -1) {
    let nextRowDataIDs: any = [];
    if (this.identityColumnName != '' && rowIndex > -1) {
      let rowCount = 1;
      for (let i = (rowIndex + 1); i < this.lstData.length; i++) {
        if (rowCount <= Number(this.nextTransactionCount)) {
          nextRowDataIDs.push(this.lstData[i][this.identityColumnName]);
          rowCount++;
        }
        else {
          break;
        }
      }
    }
    this.cellClickEvent.emit({ columnName: columnName, rowData: rowData, nextRowDataIDs: nextRowDataIDs });
  }

  isvisiblefn(page) {
    let to = (Number(this.NewPage) + 5) <= this.pagearray.length ? (Number(this.NewPage) + 5) : this.pagearray.length
    let from = (Number(this.NewPage) - 5) <= 0 ? 0 : (Number(this.NewPage) - 5)

    this.posttrail = to < this.pagearray.length ? true : false;
    this.pretrail = from > 0 ? true : false

    if (page <= to) {
      if (page > from) {
        return true;
      }
      else {
        return false;
      }

    }
    else {
      return false;
    }

  }

  ispretrail(page) {
    return false;
  }
  isposttrail(page) {
    return false;
  }

  checkDataFiltered() {
    this.isDataFiltered = false;
    if (this.txtURN != '' || this.ddlPriority != '' || this.txtInputType != '' || this.txtInputFrom != '') {
      this.isDataFiltered = true;
    }
    if (this.isDataFiltered == false) {
      this.advanceSearchFields.forEach(f => {
        if (f.search_value != '' && f.search_value != null && f.search_value != undefined) {
          this.isDataFiltered = true;
        }
      });
    }
  }

  getCellStyle(col: any): Object {

    if (col.toLowerCase() == "attachment" || col.toLowerCase() == "urn") {
      return { 'cursor': 'pointer', 'color': 'var(--title-color)', 'font-weight': 500 };
    } {
      return {};
    }
  }

  scrollGrid(direction: string): void {
    if (direction == 'next') {
      this.scrollableGrid.nativeElement.scrollLeft += 500;
    } else {
      this.scrollableGrid.nativeElement.scrollLeft -= 500;
    }

  }

  hasVisibleColumns(cols: any): boolean {
    return cols.filter(x => x.is_visible == true).length > 0;
  }

  sortByColumn(column: string) {
    let sortOrder = false;
    if (this.sortColumnInfo.name == column)
      sortOrder = !this.sortColumnInfo.isOrderAsc;
    else
      this.sortColumnInfo.name = column;

    this.sortColumnInfo.isOrderAsc = sortOrder;

    // if (sortOrder)
    //   this.lstData.sort((a, b) => a[column] < b[column] ? -1 : a[column] > b[column] ? 1 : 0);
    // else
    //   this.lstData.sort((a, b) => b[column] < a[column] ? -1 : b[column] > a[column] ? 1 : 0);
    if (sortOrder)
      this.lstData.sort((a, b) => (new Date(a[column]).toString() == 'Invalid Date' ? a[column] : new Date(a[column]).getTime()) < (new Date(b[column]).toString() == 'Invalid Date' ? b[column] : new Date(b[column]).getTime()) ? -1 : (new Date(a[column]).toString() == 'Invalid Date' ? a[column] : new Date(a[column]).getTime()) > (new Date(b[column]).toString() == 'Invalid Date' ? b[column] : new Date(b[column]).getTime()) ? 1 : 0);
    else
      this.lstData.sort((a, b) => (new Date(b[column]).toString() == 'Invalid Date' ? b[column] : new Date(b[column]).getTime()) < (new Date(a[column]).toString() == 'Invalid Date' ? a[column] : new Date(a[column]).getTime()) ? -1 : (new Date(b[column]).toString() == 'Invalid Date' ? b[column] : new Date(b[column]).getTime()) > (new Date(a[column]).toString() == 'Invalid Date' ? a[column] : new Date(a[column]).getTime()) ? 1 : 0);
  }

  changePage(direction: string, pageNo: number) {
    if (direction == 'prev')
      this.NewPage = this.NewPage == 1 ? 1 : Number(this.NewPage) - 1;
    if (direction == 'next')
      this.NewPage = this.NewPage == this.totalPages ? this.totalPages : Number(this.NewPage) + 1;
    else if (pageNo > 0)
      this.NewPage = pageNo;

    var len = this.lstData.length;
    if (this.lstData.length > 0 && this.Isserversidepaginationenabled == true) {
      len = this.lstData[0].TotalRecordsCount
    }
    this.firstRecord = ((this.NewPage * this.recordsPerPage) - this.recordsPerPage) + 1;
    var val = (Number(this.firstRecord - 1) + Number(this.recordsPerPage));

    this.LastRecord = (val < len) ? val : len;
    this.currentPage = this.NewPage;
    this.setAdvanceGridLocalStorageForPagination();
  }

  changeRecordsPerPage() {

    this.len = this.lstData.length;
    if (this.lstData.length > 0 && this.Isserversidepaginationenabled) {
      this.len = this.lstData[0].TotalRecordsCount
    }

    this.recordsPerPage = Number(this.recordsPerPage);

    this.totalPages = Math.ceil(this.len / this.recordsPerPage);
    this.currentPage = 1;

    this.firstRecord = 1;

    this.LastRecord = (this.recordsPerPage < this.len) ? this.recordsPerPage : this.len;

    this.setAdvanceGridLocalStorageForPagination();

  }

  downloadExcel() {
    if (this.Isserversidepaginationenabled == false) {
      //this.commonService.exportAsExcelFile(this.lstData, 'transaction-summary');
      this.commonService.exportAsExcelFile(this.lstData, 'Unlock-Items-List');
    }
    else {
      this.downloadalldata.emit();
    }
  }

  openMagnifySearchModal(field: any) {



    let dependantFieldValues = {};
    if (field.magnify_dependant_fields != null) {
      let magnifyDependantFields = JSON.parse(field.magnify_dependant_fields);
      Object.keys(magnifyDependantFields).forEach(x => {
        let field = this.advanceSearchFields.find(f => f.db_column_name == magnifyDependantFields[x]);
        if (field != undefined) {
          let field_value = field.search_value;
          if (field_value != null && field_value != '' && field_value != undefined) {
            // if (field.control_type == 'DROPDOWN') {
            //   field_value = field.options.find(d => d.id == field_value).name;
            // }
            dependantFieldValues[x] = field_value.toString();
          }
        }

      });
    }

    const modalRef = this.modalService.open(MagnifyFieldSearchComponent, { size: 'xl', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.fieldMappingDetailId = field.field_mapping_detail_id;
    if (field.control_type.toLowerCase() != 'dropdown')
      modalRef.componentInstance.predefinedTableColumnName = field.predefined_table_column_name;
    modalRef.componentInstance.predefinedTableTextColumnName = field.predefined_table_column_name;
    modalRef.componentInstance.dependantFieldValues = dependantFieldValues;
    modalRef.componentInstance.selectRecord.subscribe((res) => {

      const selectedField = this.advanceSearchFields.find(x => x.field_mapping_detail_id == res.fieldId);
      selectedField.search_value = res.fieldValue;
      if (selectedField.control_type == 'DROPDOWN') {
        selectedField.options = [{ id: res.fieldValue, name: res.selectedText }];
        // if dependent field in advance search then add code here
      }
      modalRef.close();
    });
    modalRef.componentInstance.closeModal.subscribe(() => {
      modalRef.close();
    })
  }

  clearAdvanceSearchField() {

    this.txtInputFrom = "";
    this.txtInputType = "";
    this.ddlPriority = "";
    this.txtURN = "";
    this.invoiceCreationDateRange = new FormGroup({
      start_date: new FormControl(),
      end_date: new FormControl(),
    });
    this.isDateRangeHasValue = false;
    this.advanceSearchFields.forEach(element => {
      element.search_value = '';
    });
    this.submitAdvanceSearch();

  }



  dateRange = {
    start_date: this.commonService.dateFormating(
      this.invoiceCreationDateRange.value.start_date
    ),
    end_date: this.commonService.dateFormating(
      this.invoiceCreationDateRange.value.end_date
    ),
  };

  submitAdvanceSearch() {
    let advanceSearchSummaryStaticFields = {
      URN: this.commonService.readInput(this.txtURN),
      Priority: this.commonService.readInput(this.ddlPriority),
      SOURCE: this.commonService.readInput(this.txtInputType),
      FROM_EMAIL: this.commonService.readInput(this.txtInputFrom),
      Created_Dt_From: this.commonService.dateFormating(
        this.invoiceCreationDateRange.value.start_date
      ),
      Created_Dt_To: this.commonService.dateFormating(
        this.invoiceCreationDateRange.value.end_date
      ),
    };
    this.checkDataFiltered();
    this.advanceSearchClickEvent.emit(advanceSearchSummaryStaticFields);
  }

  columnsFilterChange() {
    this.columnsFilterChangeEvent.emit(this.lstHeaders);
  }

  onchangecurrentPage($event) {

    this.selectPage($event.target.value)
  }

  selectPage(page: string) {

    this.currentPage = Number(page) || 1;
    this.setAdvanceGridLocalStorageForPagination();
  }

  formatInput(input: HTMLInputElement) {
    input.value = input.value.replace(FILTER_PAG_REGEX, '');
    let inputPage = Number(input.value)
    if (this.totalPages < inputPage) {
      input.value = this.totalPages.toString();
    }
  }

  setAdvanceGridLocalStorageForPagination() {

    this.setPaginationLocalStorageEvent.emit();
  }

  setDecimalPlaces(value: any, decimalPlace: number, validationType: string) {
    return validationType.toLowerCase() == 'numeric' ? parseFloat(value == '' ? 0 : value) : value;
    //.toFixed(Number(decimalPlace)) : value;
  }

  onInvoiceCreationDateChanges() {
    if (
      this.invoiceCreationDateRange.value.start_date != '' ||
      this.invoiceCreationDateRange.value.end_date != ''
    ) {
      this.isDateRangeHasValue = true;
    }
  }

  resetInvoiceCreationDateRange() {
    this.invoiceCreationDateRange = new FormGroup({
      start_date: new FormControl(),
      end_date: new FormControl(),
    });
    this.isDateRangeHasValue = false;
  }

  HeaderCheckBoxChanged(model: any) {

    // this.lstData.forEach(d => {
    //   d.action_checkbox_button = this.isMasterSel;
    // })

    if (model.checked == true) {
      this.isMasterSel = true;
      this.lstData.forEach(d => {
        d.action_checkbox_button = true;
      })
    } else {
      this.lstData.forEach(d => {
        d.action_checkbox_button = false;
      })
    }
    this.headercheckboxClickEvent.emit({ model });
    //this.isAllSelected()
  }

  onSelectionChange(event: any, index: number, colName: string) {
    this.lstData[index][colName].forEach(element => {
      element.selected = false;
    })
    let currentIndex = this.lstData[index][colName].findIndex(a => a.value === event.value)
    this.lstData[index][colName][currentIndex].selected = true;

    this.dropDownClickEvent.emit({ event, index, colName });
  }

  isAllSelected() {
    let count: number = this.lstData.length;
    let trueCount: number = 0;
    this.lstData.forEach(d => {

      if (d.action_checkbox_button == true) {
        trueCount += 1;
      }
    })
    if (count == trueCount) {
      this.isMasterSel = true;
    }
    else {
      this.isMasterSel = false;
    }


  }
  changeDropdownFieldValue(field: any, value: any) {
    if (field.is_dependant == 1) {
      // let option = field.options.find((d) => d.name == this.frmTransaction.get(field.db_column_name).value);
      // let fieldVal = option.id;
      // this.getDependantFields(field.field_mapping_detail_id, fieldVal);
      this.getDependantFields(
        field.field_mapping_detail_id,
        value, field
      );
    }




  }
  getDependantFields(fieldMappingDetailId: number, selectedValue: any, field: any) {
    let params = new HttpParams();
    params = params.append('field_mapping_detail_id', fieldMappingDetailId);
    params = params.append('selected_value', selectedValue);
    params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));
    this.dataService.getData('dependant', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res != undefined) {
          if (res.data ?.length > 0) {
            res.data.forEach((ele) => {
              ele.values = JSON.parse(ele.values);
              if (ele.control_type == 'DROPDOWN') {
                // this.activeFieldList.find((x) =>
                //   x.field_details.find((f) => {
                //if (field.db_column_name== ele.db_column_name) {
                const uniqueData = [...new Map(ele.values.map(item => [item['name'], item])).values()];

                if (ele.values.length > 0) {
                  var isDependentSelected = ele.values[0].hasOwnProperty('selected');
                  const selectedField = this.advanceSearchFields.find(x => x.db_column_name === ele.db_column_name);
                  if (!isDependentSelected) {
                    selectedField.options = ele.values;

                  }
                  else {
                    selectedField.option = ele.values[0]['id'];
                    //ele.db_column_name.setValue(ele.values[0]['id']);
                  }
                  if (uniqueData.length == 1 && !isDependentSelected) {
                    ele.db_column_name.setValue(uniqueData[0]['id']);
                  }
                }
                //}
                //   })
                // );
              } else if (ele.control_type == 'TEXTBOX' && ele.values.length > 0) {
                ele.db_column_name.setValue(ele.values[0].name);
              }
            });
          }
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }
  //added by sana for limit the input field length- start
  limitLength(event: Event, maxLength: number) {
    var input = event.target as HTMLInputElement;
    if (input.value.length > maxLength) {
      input.value = input.value.slice(0, maxLength);
    }
  }
  //added by sana for limit the input field length- end
}
